<cs-header>
  <cs-header-title>{{ LL.editWorkouts.title() }}</cs-header-title>
  <!-- overflow menu for all users: Volume Optimization (the old calculator action) +
       the flag-gated Scan Workout entry -->
  <cs-icon-button header-right icon="ellipsis-vertical" (click)="openHeaderMenu($event)"></cs-icon-button>
  <cs-header-content>
    <!-- Workout tabs: A, B, C, D, + -->
    <cs-tab [(selection)]="selectedWorkoutName" (selectionChange)="onWorkoutSelected($event)">
      @for (workout of workouts; track trackByWorkout($index, workout)) {
        <cs-tab-button [value]="workout.name">
          <cs-label>{{ workout.name }}</cs-label>
        </cs-tab-button>
      }
      <cs-tab-button [value]="'add'" class="add-workout-tab">
        <cs-icon name="add"></cs-icon>
      </cs-tab-button>
    </cs-tab>
  </cs-header-content>
</cs-header>

<cs-tab-content-container [selection]="selectedWorkoutName"
  [swipeEnabled]="hasClientSmallScreen()" (swipeForward)="handleSwipeForward()" (swipeBack)="handleSwipeBack()">
  <!-- Tab content for each workout -->
  @for (workout of workouts; track trackByWorkout($index, workout)) {
    <cs-tab-content
      [value]="workout.name">
      <cs-content [loading]="loading">
        @if (exercisesLoadFailed) {
          <!-- an exercise could not be read: show no rows rather than a stale or partial list -->
          <cs-empty-state iconName="warning"
            [title]="LL.editWorkouts.exercisesLoadFailed.title()"
            [subtext]="LL.editWorkouts.exercisesLoadFailed.message()">
            <cs-button secondary (click)="onRetryLoadExercisesClick()">{{ LL.common.buttons.tryAgain() }}</cs-button>
          </cs-empty-state>
        } @else {
        <!-- Exercise list with edit mode -->
        <cs-exercise-list [exercises]="getExercisesForWorkout(workout.name)" [foldable]="false" [showMoreButton]="true"
          [editable]="true" (exercisesReordered)="onExercisesReordered(workout.name, $event)"
          (insertActionClick)="onInsertActionClick(workout.name, $event)"
          (exerciseMoreOptionsClick)="onExerciseMoreOptionsClick($event)"
          (exerciseHeaderClick)="onExerciseHeaderClick($event)">
          <!-- Delete workout button - projected into footer for proper animation -->
          <cs-card-list-row footer-cards class="delete-workout-row">
            <cs-button tertiary warning (click)="onDeleteWorkoutClick()" icon="trash"
            [label]="LL.editWorkouts.buttons.deleteWorkout({ name: workout.name })"></cs-button>
          </cs-card-list-row>
        </cs-exercise-list>
        }
      </cs-content>
    </cs-tab-content>
  }
</cs-tab-content-container>

<!-- Action buttons - MUST be after cs-content -->
<cs-page-action-buttons>
  <cs-button secondary medium icon="undo" (click)="onRevertClick()"
  [label]="LL.editWorkouts.buttons.revert()"></cs-button>
  <cs-button primary medium (click)="onSaveAndExitClick()" [label]="LL.editWorkouts.buttons.save()"></cs-button>
</cs-page-action-buttons>
